<div class="flex flex-col h-full">
  <div class="p-2 shrink-0">
    <p-iconfield iconPosition="left">
      <p-inputicon styleClass="fa fa-search" />
      <input
        type="text"
        pInputText
        [placeholder]="'fields.search' | translate"
        [ngModel]="filterText()"
        (ngModelChange)="filterText.set($event)"
        class="w-full"
      />
    </p-iconfield>
  </div>

  <!-- One scroll container for both axes: the horizontal scrollbar sits at
       the bottom edge of this fixed-height list area, not under the last row.
       cosmosScrollFade adds edge fades so it's clear content continues —
       the side fades are kept narrow + faint since side-scroll is secondary. -->
  <div
    cosmosScrollFade
    [fadeSizeX]="'0.75rem'"
    [fadeOpacityX]="0.1"
    class="relative flex-1 min-h-0"
  >
    <div class="absolute inset-0 overflow-auto px-1">
      @if (treeService.loading()) {
        <div class="flex flex-col gap-3 p-3">
          @for (i of [1, 2, 3, 4, 5]; track i) {
            <p-skeleton height="1.25rem" width="{{ 60 + (i % 3) * 10 }}%" />
          }
        </div>
      } @else if (treeService.error()) {
        <p class="text-sm text-surface-500 p-3">{{ 'common.error.loadingData' | translate }}</p>
      } @else {
        <p-tree
          [value]="treeNodes()"
          selectionMode="single"
          (onNodeSelect)="onNodeSelect($event)"
          styleClass="min-w-full w-max border-none"
        >
          <ng-template let-node pTemplate="default">
            @if (node.data.type === 'measurement') {
              <span
                [class.text-primary-500]="node.data.id === activeMeasurementId()"
                [class.font-semibold]="node.data.id === activeMeasurementId()"
                class="block whitespace-nowrap"
              >
                {{ node.label }}
              </span>
            } @else {
              <span
                [class.text-primary-500]="node.data.id === activeStageId()"
                [class.font-semibold]="node.data.id === activeStageId()"
                class="block whitespace-nowrap"
              >
                {{ node.label }}
              </span>
            }
          </ng-template>
        </p-tree>
      }
    </div>
  </div>
</div>
